import { FC, JSX } from 'react';

import { Button, Flex } from 'antd';
import classNames from 'classnames';
import dayjs from 'dayjs';

import { DEFAULT_DATE_UAS_FORMAT_MOBILE } from '@/constants/defaultDateFormat';

import styles from './DebtsSubmission.module.scss';
import { DebtsSignature } from './components/debts-signature';

import { InputFormItem } from '@/components';

type TDebtsSubmissionProps = {
	isPending: boolean;
};

export const DebtsSubmission: FC<TDebtsSubmissionProps> = ({ isPending }): JSX.Element => {
	return (
		<Flex className={styles['container']} vertical>
			<span>
				I certify the information above to be true and accurate. For any debt to be refinanced, I
				certify on behalf of the Small Business Applicant, that the proceeds from each debt to be
				refinanced were used exclusively for the Applicant&apos;s business and no portion of the
				original debt was used for personal expenses, or any other ineligible purpose as set forth
				in{' '}
				<a
					href="https://www.ecfr.gov/current/title-13/chapter-I/part-120/subpart-A/subject-group-ECFRf4e36c83c2b40a5/section-120.130"
					rel="noreferrer"
					target="_blank"
				>
					13 CFR § 120.130 ***
				</a>
			</span>
			<Flex className={styles['signature-submit']}>
				<Flex className={styles['signature-container']}>
					<Flex
						className={classNames(styles['signature-item'], styles['name-block'])}
						gap={8}
						vertical
					>
						<span className={styles['label']}>Signer&apos;s Name</span>
						<InputFormItem
							formItemProps={{
								name: ['borrowerSignature', 'signerName'],
								rules: [{ required: true }],
								style: { marginBottom: 0 },
							}}
							inputProps={{
								placeholder: 'Enter your name',
								variant: 'underlined',
							}}
						/>
					</Flex>
					<Flex
						className={classNames(styles['signature-item'], styles['date-block'])}
						gap={8}
						vertical
					>
						<span className={styles['label']}>Date</span>
						<span className={styles['date']}>{dayjs().format(DEFAULT_DATE_UAS_FORMAT_MOBILE)}</span>
					</Flex>
					<Flex
						className={classNames(styles['signature-item'], styles['signature-block'])}
						gap={8}
						vertical
					>
						<DebtsSignature />
					</Flex>
				</Flex>
				<Flex align="center" className={styles['submit-button']} justify="flex-end">
					<Button
						disabled={isPending}
						htmlType="submit"
						loading={isPending}
						style={{ width: 'fit-content' }}
						type="primary"
					>
						Submit
					</Button>
				</Flex>
			</Flex>
		</Flex>
	);
};
